<script setup>
import {onMounted, ref} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import moment from "moment";
import {getRoute} from "@/hooks/getRoute.js";
import {listMemberLevelLog} from "@/api/memberLevelLog/memberLevelLog.js";
// 路由信息
const {route} = getRoute();

// 用户Id
const memberId = ref()
/*初次加载*/
onMounted(async () => {
  if(!route.query.memberId) {
    return ElMessage.error("无法获取会员ID")
  }
  memberId.value = route.query.memberId
  await handleSearch()
})

/*搜索功能*/
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    const param = {
      memberId: memberId.value
    }
    loading.value = true;
    const res = await listMemberLevelLog(page, param);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '用户Id', key: 'userId', nowrap: true },
  { title: '名称', key: 'nickname', nowrap: true },
  { title: '购买会员等级', key: 'levelName', nowrap: true },
  { title: '月费/年费', key: 'billingCycle', nowrap: true },
  { title: '有效期', key: 'memberExpireTime', nowrap: true },
  { title: '购买时间', key: 'memberPurchaseTime', nowrap: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
</script>

<template>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.billingCycle="{ item }">
            <div v-if="item.billingCycle === 'MONTHLY'">月费</div>
            <div v-if="item.billingCycle === 'ANNUAL'">年费</div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :page-size="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
::marker {
  content: none;
}
</style>